export default {
  title: 'Global',
  alert: {
    updated_successfully: 'E-mail updated successfully!',
  },
  button_save: 'save',
  form_labels: {
    email: 'E-mail',
  }
}